<template>
  <v-container clipped fill-height fixed fluid class="pa-0 mt-5">
    <v-global-progress-bar namespace="valueMapping" :flags="progressBarFlags" />
    <v-value-mapping-toolbar />
    <v-value-mapping-sidebar />
    <v-layout>
      <v-value-mapping-content />
    </v-layout>
  </v-container>
</template>

<script>
import VGlobalProgressBar from "@/components/progress/GlobalProgressBar.vue";
import VValueMappingContent from "./content/Layout.vue";
import VValueMappingSidebar from "./sidebar/Layout.vue";
import VValueMappingToolbar from "./toolbar/Layout.vue";

export default {
  components: {
    VGlobalProgressBar,
    VValueMappingContent,
    VValueMappingSidebar,
    VValueMappingToolbar
  },
  data: () => ({
    progressBarFlags: [
      "loadingClassifications",
      "loadingFeature",
      "loadingFeatures",
      "loadingRemoveValue",
      "loadingSaveActiveMap",
    ]
  })
};
</script>
